<template>
    <div class="h-full border-r overflow-y-scroll">

        <sub-menu
            :links="links"
            header="Wills"
        ></sub-menu>

    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import SubMenu from '@/components/menu/SubMenu.vue'
import menus from '@/utils/menus'

export default defineComponent({
    name: 'ResidentialSidebar',
    components: {
        SubMenu
    },
    setup() {
        const { willSidebarLinks } = menus();

        return {
            links: willSidebarLinks,
        }
    }  
})
</script>